export enum LOADER_TYPE {
  PROGRESS = 'progress',
  INFINITE = 'infinite',
}

export interface Loader {
  status: boolean;
  type: LOADER_TYPE;
  value?: number;
  text?: string;
}
